(function() {
    angular.module('ngmvac').
    directive('hotelMapRates', ['$compile', function($compile) {
        // directive link function
        var link = function(scope, element, attrs) {
            var hotel = [];
            if(attrs.marca == 'mvac'){
                styleOutle = {};
                markerIcon = '/img/marker.png';
            }else{
                markerIcon = '/outlet_img/marker.png';
            }

            initMap = function() {
                var center = new google.maps.LatLng(1, 1);
                bounds = new google.maps.LatLngBounds();
                var map = new google.maps.Map(element[0], {
                    zoom: 10,
                    center: center,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    scrollwheel: false,
                    styles: styleOutle
                });
                var marker, infowindow;
                var count = 0;
                for (var i = 0; i < scope.hoteles.length; i++) {
                    //if(scope.hoteles[;;i].name == 'La Quinta Inn & Suites Las Vegas Tropicana')
                    if(angular.isDefined(scope.hoteles[i].packageGrouped)){
                        count++;
                    }
                    
                    if(scope.hoteles[i].latitude!=0 && angular.isDefined(scope.hoteles[i].rooms)){
                    marker = new google.maps.Marker({
                        position: new google.maps.LatLng(scope.hoteles[i].latitude, scope.hoteles[i].longitude),
                        icon: attrs.urlmarker + markerIcon,
                    });
                    bounds.extend(marker.position);
                    marker.setMap(map);
                    infowindow = new google.maps.InfoWindow({
                        content: "loading...",
                        maxWidth: 430
                    });
                    if(attrs.marca == 'mvac')
                    google.maps.event.addListener(marker, 'mouseover', (function(index) {
                        return function() {
                            var URLactual = window.location.href;
                            infowindow.setContent("loading...");
                            html = "";
                            html += "<div onimg='cotizador.imagenhotelmapa()' class='markerModal'>";
                            html += "<div class='row mr0'>";
                            html += "<div class='col-md-4 pr0'>";
                            html += "<div align='center' style='margin-top:25px;' class='wrap-img-map-modal'>";
                            html += "<i class='fa fa-spinner fa-spin fa-3x fa-fw'></i>";
                            html += "<span class='sr-only'>Loading...</span>";
                            html += "</div>";
                           // html += "<div style='margin-top:3px'>desde";
                           // var iconocurrency = "";
                           // if (scope.hoteles[index].currency == 'USD') {
                           //     iconocurrency = "$";
                           // } else if (scope.hoteles[index].currency == 'EUR') {
                           //     iconocurrency = "€";
                           // } else if (scope.hoteles[index].currency == 'GBP') {
                            //    iconocurrency = "£";
                            //} else if (scope.hoteles[index].currency == 'MXN') {
                            //    iconocurrency = "$";
                           // }
                            //html += "<div class='priceMap'>" + scope.hoteles[index].currency + " " + iconocurrency + (scope.hoteles[index].minRatePublica / scope.hoteles[0].total_noches).toFixed(2) + "</div>";
                            //html += "</div>";
                            var name = scope.hoteles[index].name.replace(/\s/g, "_");
                            //html += "<a class='btn btn-danger btn-sm btn-block btn-sel' href='" + URLactual + "/details/" + name + "'>Seleccionar</a>";
                            html += "</div>";
                            html += "<div class='col-md-8'>";
                            html += "<div class='priceMap'>" + scope.hoteles[index].name + "</div>";
                            html += "<div id='info" + scope.hoteles[index].code + "'></div>";
                            html += "<div class='label label-success lbver'>" + scope.hoteles[index].zoneName + ", " + scope.hoteles[index].destinationName + "</div>";
                            html += "</div>";
                            html += "</div>";
                            hotel = scope.hoteles[index];
                            scope.img(hotel).then(function(response)
                                //  http://local.mexicovacations.com.mx/hotel/details/Grand_Oasis_Cancun
                                {
                                    var content = response.data.hotels;
                                    hotel.content = content;
                                    html2 = "";
                                    html2 += "<div onimg='cotizador.imagenhotelmapa()' class='markerModal'>";
                                    html2 += "<div class='row mr0'>";
                                    html2 += "<div class='col-md-4 pr0'>";
                                    html2 += "<div class='wrap-img-map-modal'>";
                                    html2 += "<img class='img-responsive' src=https://photos.hotelbeds.com/giata/" + hotel.content[0].images[0].path + ">";
                                    html2 += "</div>";

                                 //   if(scope.hoteles[index].packageGrouped[0][0].price != scope.hoteles[index].packageGrouped[0][0].priceWithoutDiscount)
                                   // {
                                       // $totaldescuento=scope.hoteles[index].packageGrouped[0][0].priceWithoutDiscount-scope.hoteles[index].packageGrouped[0][0].price;
                                    // $descuento=(($totaldescuento*100)/scope.hoteles[index].packageGrouped[0][0].priceWithoutDiscount)*(-1);


                                    //html2 += "<div class='label-descuento-mapa ng-scope' tooltip='' title=''>";
                                    //html2 += "<div class='promo_1_mapa'>¡HOY!</div>";
                                   // html2 += "<div class='promo_2_mapa ng-binding'>"+$descuento.toFixed(0)+"%</div>";
                                   // html2 += "</div>";
                                    //}

                                    //html2 += " <div class='spInmapa'>Promedio por noche</span></div>";
                                    //html2 += "<div style='margin-top:3px'>desde";
                                    //var iconocurrency = "";
                                    //if (scope.hoteles[index].currency == 'USD') {
                                     //   iconocurrency = "$";
                                    //} else if (scope.hoteles[index].currency == 'EUR') {
                                     //   iconocurrency = "€";
                                    //} else if (scope.hoteles[index].currency == 'GBP') {
                                     //   iconocurrency = "£";
                                    //} else if (scope.hoteles[index].currency == 'MXN') {
                                     //   iconocurrency = "$";
                                   // }
                                   // html2 += "<div class='priceMap'>" + scope.hoteles[index].currency + " " + iconocurrency + (scope.hoteles[index].minRatePublica / scope.hoteles[0].total_noches).toFixed(2) + "</div>";
                                    //html2 += "</div>";
                                    var name = scope.hoteles[index].name.replace(/\s/g, "_");
                                   // html2 += "<a class='btn btn-danger btn-sm btn-block btn-sel' href='" + URLactual + "/details/" + name + "'>Seleccionar</a>";
                                    html2 += "</div>";
                                    html2 += "<div class='col-md-8'>";
                                    html2 += "<div class='priceMap'>" + scope.hoteles[index].name + "</div>";
                                    html2 += "<div id='info" + scope.hoteles[index].code + "'></div>";
                                    html2 += "<div class='label label-success lbver'>" + scope.hoteles[index].zoneName + "</div>";
                                    if (hotel.content[0].description.content.length > 100) {
                                        html2 += "<div id='descripcorta' class='text-justify'>" + hotel.content[0].description.content.substring(0, 100) + " ..." + "</div>";
                                        html2 += "<div id='descriplarga' class='text-justify' style='display:none;'>" + hotel.content[0].description.content + "</div>";
                                        html2 += "<a id='vermas' style='cursor:pointer;' onclick='Vermas();'>Ver mas.</a>";
                                        html2 += "<a id='vermenos' style='cursor:pointer; display:none;' onclick='Vermenos();'>Ver menos.</a>";
                                    } else {
                                        html2 += "<div class='text-justify'>" + hotel.content[0].description.content + "</div>";
                                    }
                                    html2 += "</div>";
                                    html2 += "</div>";
                                    infowindow.setContent(html2);
                                    angular.element('#info' + scope.hoteles[index].code).append(htmlStars);
                                }).catch(function(err) {
                            });
                            infowindow.setContent(html);
                            var htmlStars = $compile('<span ng-model="hoteles[' + index + '].categoryCode" star-rate category-name="hoteles[' + index + '].categoryName"></span>')(scope);
                            angular.element('#info' + scope.hoteles[index].code).append(htmlStars);
                            infowindow.open(map, this);
                        }
                    })(i));
                    google.maps.event.addListener(marker, 'mouseout', function() {
                        //infowindow.close();
                    });
                    google.maps.event.addDomListener(map, 'click', function() {
                        infowindow.close();
                    });
                }
                }
                if(attrs.marca == 'mvac'){
                    window.setTimeout(function() {
                        currentCenter = map.getCenter();
                        google.maps.event.trigger(map, 'resize');
                        map.setCenter(currentCenter);
                        map.fitBounds(bounds);
                        if (scope.hoteles.length == 1) {
                            zoomChangeBoundsListener = google.maps.event.addListenerOnce(map, 'bounds_changed', function(event) {
                                if (this.getZoom()) {
                                    this.setZoom(19);
                                }
                                infowindow.open(map, marker);
                            });
                            setTimeout(function() {
                                google.maps.event.removeListener(zoomChangeBoundsListener)
                            }, 2000);
                        }
                    }, 1000);                    
                }else{
                    currentCenter = map.getCenter();
                    google.maps.event.trigger(map, 'resize');
                    map.setCenter(currentCenter);
                    map.fitBounds(bounds);
                }
            }
            initMap();
            
            // scope.$watch(function(scope) {
            //     return scope.hoteles;
            // }, function(newValues, oldValues) {
            //     // console.log("newValues", newValues);
            //     // console.log("oldValues", oldValues);
            //     // console.log(angular.equals(newValues, oldValues));
            //     initMap();
            //     if(!angular.equals(newValues, oldValues)){
            //         console.log("initMap");
            //         initMap();
            //     }
            // });

            // attrs.$observe('hoteles', function(){
            //     initMap();
            // });

            //initMap();
        };
        return {
            restrict: 'A',
            template: '<div class="mapa-rates"></div>',
            replace: true,
            link: link,
            controller: ['$scope', 'ContentApiService', function(scope, resul) {
                scope.img = function(hotel) {
                    return resul.get([hotel.code], ['images', 'categoryCode', 'description', 'chainCode']);
                }
            }],
            scope: {
                hoteles: "="
            }
        };
    }]);
})();